import api from '../../api'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  isOn: (state) => (place) => state.all.includes(place.id),
  getFavorites: (state) => state.all,
  getFavoritedPlaces: (state, _getters, _rootState, rootGetters) => {
    const places = _.cloneDeep(rootGetters['places/getPlaces'])
    const favorites = state.all
    return places.filter(place => {
      return favorites.includes(place.id)
    })
  }
}

const actions = {
  fetchAll ({ rootGetters, commit }) {
    const token = rootGetters['user/getToken']

    return new Promise((resolve, reject) => {
      api.getFavorites(token)
        .then((favorites) => {
          commit('setFavorites', favorites)
          resolve()
        })
        .catch(() => reject())
    })
  },
  create ({ rootGetters, commit }, place) {
    const token = rootGetters['user/getToken']

    return new Promise((resolve, reject) => {
      api.putFavorite(place, token)
        .then(() => {
          commit('push', place)
          resolve()
        })
        .catch(() => reject())
    })
  },
  delete ({ rootGetters, commit }, place) {
    const token = rootGetters['user/getToken']

    return new Promise((resolve, reject) => {
      api.deleteFavorite(place, token)
        .then(() => {
          commit('destroy', place)
          resolve()
        })
        .catch(() => reject())
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setFavorites (state, favorites) {
    state.all = favorites
  },
  push (state, place) {
    state.all.push(place.id)
  },
  destroy (state, place) {
    const index = state.all.findIndex(id => id === place.id)

    if (index > -1) { state.all.splice(index, 1) }
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
